export const LAST_MOVE_MARKER = { class: 'marker-last-move', slice: 'markerSquare' };
